import * as React from "react";
import Nav from "../../components/Nav/Nav";
import styled from "../../styled-components";
import Footer from "../../components/Footer/Footer";
import { Container as DefaultContainer } from "../../components/Container/Container";
import { Link as DefaultLink } from "react-router-dom";

const linkStyles = `
  color: #11CC99;
  font-weight: 600;
  line-height: 24px;
  text-decoration: none;

  &:hover {
    cursor: pointer;
  }
`;

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
  overflow-x: hidden;
`;

const Container = styled(DefaultContainer)`
  display: flex;
  flex: 1 1 auto;
  height: calc(100vh - 20px);
  justify-content: center;
  padding: 100px 20px;
`;

const Title = styled.p`
  color: ${({ theme }) => theme.colors.black};
  font-size: 30px;
  font-weight: 400;
  line-height: 40x;
`;

const Description = styled.p`
  color: ${({ theme }) => theme.colors.black};
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  margin-top: 20px;
`;

const Link = styled(DefaultLink)`
  ${linkStyles};
`;

const AnchorLink = styled.a`
  ${linkStyles};
`;

const ExtendedFooter = styled(Footer)`
  margin-top: auto;
`;

export const NotFound = () => (
  <Wrapper>
    <Nav showSayLogo={true} linkColor="#505050" linkColorHover="#000000" />

    <Container flexDirection="column">
      <Title>Oops! The page you’re looking for was not found.</Title>

      <Description>
        You can <Link to="/">return to our front page</Link>, or{" "}
        <AnchorLink href="mailto:support@saytechnologies.com">
          send us a message
        </AnchorLink>{" "}
        if you can’t find what you are looking for.
      </Description>
    </Container>

    <ExtendedFooter />
  </Wrapper>
);



// WEBPACK FOOTER //
// ./src/pages/NotFound/NotFound.tsx